/* =====================================================================
 * Kissen Editor — daten-getriebene Engine (Port aus collage-engine.html)
 * =====================================================================
 * Ein Editor für alle Kissen-Layouts. `layout-id` (Root-Dataset, aus Section-
 * Setting) bestimmt, welches der 5 Layouts gerendert wird. Jedes Produkt hat
 * eine -gestalten-Page mit eigenem layout_id.
 *
 * Flow:
 *   1. Layout aus LAYOUTS[layoutId] laden → flache Design-Stage rendern.
 *   2. Foto-Tab: "Fotos hochladen" (multi) füllt leere Slots der Reihe nach;
 *      Tap auf Slot in der Vorschau ersetzt einzeln. Sofort objectURL-Preview,
 *      Original im Hintergrund nach S3 (/api/v1/upload/presigned-url/).
 *   3. Text-Tab: pro editierbarem Layout-Text ein Feld → Live-DOM-Update.
 *   4. Produkt-Tab: Größen-Picker → Variant-ID + Preis.
 *   5. Live-Vorschau = der Editor selbst: die Stage liegt (auf die Kissen-
 *      Silhouette maskiert) direkt auf der Kissen-Front, Schatten/Licht darüber.
 *   6. Cart-Add: /cart/add.js mit Config-JSON + _Provider=merchone + _job_id.
 *      Server-Render kommt in Phase 3 (404 → Fallback-URL, wie Foto-Decke).
 * ===================================================================== */

(function () {
  'use strict';

  const BACKEND_API_URL = window.KISSEN_BACKEND_API_URL || 'https://tiles.distantlines.de';
  const MAX_FILE_SIZE_MB = 20;
  const ACCEPTED_TYPES = ['image/jpeg', 'image/png', 'image/heic', 'image/heif'];
  const CROPPER_CSS_URL = 'https://cdn.jsdelivr.net/npm/cropperjs@1.6.2/dist/cropper.min.css';
  const CROPPER_JS_URL = 'https://cdn.jsdelivr.net/npm/cropperjs@1.6.2/dist/cropper.min.js';

  /* ===================================================================
   * LAYOUT-CONFIGS — die 5 V1-Kissen-Layouts (1:1), Port aus collage-engine.html.
   * texts mit fixed:true sind dekorativ (kein Eingabefeld im Text-Tab).
   * =================================================================== */
  const LAYOUTS = {
    'heart-collage': {
      id: 'heart-collage', name: 'Herz-Collage', aspect: '1 / 1',
      blanketPad: 0, photoStyle: 'mat', blanketColor: '#1c3e60',
      grid: { cols: '1fr', rows: '1fr', gap: 0 },
      photos: [
        { x: 23.5, y: 7.0, w: 13, h: 16, rot: -10 }, { x: 33.0, y: 5.5, w: 16, h: 13, rot: 6 },
        { x: 51.0, y: 5.5, w: 16, h: 13, rot: -6 }, { x: 63.5, y: 7.0, w: 13, h: 16, rot: 10 },
        { x: 10.5, y: 19.0, w: 13, h: 16, rot: -14 }, { x: 22.0, y: 17.5, w: 16, h: 13, rot: -4 },
        { x: 35.5, y: 16.5, w: 15, h: 15, rot: 5 }, { x: 49.5, y: 16.5, w: 15, h: 15, rot: -5 },
        { x: 62.0, y: 17.5, w: 16, h: 13, rot: 4 }, { x: 76.5, y: 19.0, w: 13, h: 16, rot: 13 },
        { x: 15.0, y: 30.5, w: 16, h: 13, rot: -9 }, { x: 30.5, y: 30.0, w: 13, h: 16, rot: 7 },
        { x: 42.0, y: 31.5, w: 16, h: 13, rot: -6 }, { x: 56.5, y: 30.0, w: 13, h: 16, rot: 6 },
        { x: 69.0, y: 30.5, w: 16, h: 13, rot: 10 }, { x: 24.5, y: 41.0, w: 13, h: 16, rot: -8 },
        { x: 37.0, y: 43.5, w: 16, h: 13, rot: 6 }, { x: 51.5, y: 42.0, w: 13, h: 16, rot: -7 },
        { x: 62.0, y: 41.5, w: 16, h: 13, rot: 8 }, { x: 32.5, y: 51.0, w: 13, h: 16, rot: -9 },
        { x: 44.0, y: 53.5, w: 16, h: 13, rot: 7 }, { x: 57.5, y: 50.0, w: 13, h: 16, rot: 9 },
        { x: 41.5, y: 60.5, w: 15, h: 15, rot: 4 }
      ],
      texts: [
        { content: 'FAMILIE MÜLLER', label: 'Familienname', free: true, x: 50, y: 88, font: 'Outfit', weight: 400, size: 2.2, color: '#b9c5d6', upper: true, spacing: '0.34em' }
      ]
    },
    'classic-heart-frame': {
      id: 'classic-heart-frame', name: 'Klassischer Herzrahmen', aspect: '1 / 1',
      blanketPad: 0, photoStyle: 'mat', blanketColor: '#eaeaea',
      grid: { cols: '1fr', rows: '1fr', gap: 0 },
      photos: [{ x: 9, y: 6, w: 82, h: 64, rot: 0 }],
      texts: [
        { content: '♥', fixed: true, free: true, x: 50, y: 79, font: 'Outfit', weight: 700, size: 2.3, color: '#d98a9a' },
        { content: 'WIR LIEBEN DICH, OMA', label: 'Spruch', free: true, x: 50, y: 85, font: 'Outfit', weight: 500, size: 2.5, color: '#4a4a4a', upper: true, spacing: '0.2em' },
        { content: 'LENA • BEN', label: 'Namen', free: true, x: 50, y: 90, font: 'Outfit', weight: 500, size: 1.5, color: '#8a8a8a', upper: true, spacing: '0.18em' }
      ]
    },
    'gallery-of-nine': {
      id: 'gallery-of-nine', name: 'Neuner-Galerie', aspect: '1 / 1',
      blanketPad: 2.2, photoStyle: 'plain', blanketColor: '#f3f3f3',
      grid: { cols: '1fr 1fr 1fr', rows: '1fr 1fr 1fr', gap: 2.2 },
      photos: [
        { c: '1/2', r: '1/2' }, { c: '2/3', r: '1/2' }, { c: '3/4', r: '1/2' },
        { c: '1/2', r: '2/3' }, { c: '2/3', r: '2/3' }, { c: '3/4', r: '2/3' },
        { c: '1/2', r: '3/4' }, { c: '2/3', r: '3/4' }, { c: '3/4', r: '3/4' }
      ],
      texts: []
    },
    'photo-gallery': {
      id: 'photo-gallery', name: 'Fotogalerie', aspect: '1 / 1',
      blanketPad: 0, photoStyle: 'plain', blanketColor: '#cccccc',
      grid: { cols: '1fr', rows: '1fr', gap: 0 },
      photos: [{ x: 0, y: 0, w: 100, h: 100, rot: 0 }],
      texts: [
        { content: 'FAMILIE MÜLLER', label: 'Name', free: true, x: 50, y: 91, font: 'Outfit', weight: 600, size: 3.4, color: '#ffffff', upper: true, spacing: '0.18em' }
      ]
    },
    'love-paw': {
      id: 'love-paw', name: 'Pfotenliebe', aspect: '1 / 1',
      blanketPad: 0, photoStyle: 'plain', blanketColor: '#cccccc',
      grid: { cols: '1fr', rows: '1fr', gap: 0 },
      photos: [{ x: 0, y: 0, w: 100, h: 100, rot: 0 }],
      overlay: { type: 'love-paw' },
      texts: [
        { content: 'L', fixed: true, free: true, x: 41, y: 83, font: 'Playfair Display', weight: 600, size: 6.5, color: '#ffffff' },
        { content: 'VE', fixed: true, free: true, x: 57.5, y: 83, font: 'Playfair Display', weight: 600, size: 6.5, color: '#ffffff' },
        { content: 'BUSTER 2008 - 2022', label: 'Name & Jahre', free: true, x: 50, y: 92, font: 'Outfit', weight: 500, size: 1.6, color: '#ffffff', upper: true, spacing: '0.2em' }
      ]
    }
  };

  const CAM = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/></svg>';

  /* ===================================================================
   * SVG-Helfer + Overlay-Builder (nur was die 5 Layouts brauchen: love-paw)
   * =================================================================== */
  const _NS = 'http://www.w3.org/2000/svg';
  function _el(tag, attrs) { const e = document.createElementNS(_NS, tag); for (const k in attrs) e.setAttribute(k, attrs[k]); return e; }
  function _svgRoot(w, h) { return _el('svg', { viewBox: '0 0 ' + w + ' ' + h, preserveAspectRatio: 'none' }); }

  function buildLovePaw() {
    const svg = _svgRoot(1000, 1000);
    const cx = 487, cy = 830, white = '#ffffff', pink = '#e7b8bf';
    svg.appendChild(_el('ellipse', { cx: cx, cy: cy + 16, rx: 33, ry: 27, fill: pink }));
    [[-29, -15, 12, 16], [-11, -30, 11, 15], [11, -30, 11, 15], [29, -15, 12, 16]].forEach(function (t) {
      svg.appendChild(_el('ellipse', { cx: cx + t[0], cy: cy + t[1], rx: t[2], ry: t[3], fill: white }));
    });
    return svg;
  }
  const OVERLAY_BUILDERS = { 'love-paw': buildLovePaw };

  /* ===================================================================
   * Modul-State (single instance — eine Section pro -gestalten-Page)
   * =================================================================== */
  let root, stage, assets, sectionId, layoutId;
  let activeLayout, currentGrid;
  const state = { texts: [], bgColor: '#cccccc', paper_size: '', variant_id: '', design_color: '#cccccc' };
  const photoSrcs = {};   // slot-index -> objectURL (Vorschau)
  const slotData = {};    // slot-index -> { user_image_url, crop:{x,y,w,h}|null }  (crop normiert 0..1, PROJ-5)
  const cropSource = {};  // slot-index -> dataURL/objectURL des Originals fürs Crop-Modal

  /* Crop in der Stage anwenden (Spiegel der Server-Logik in print-mode.js:applyCrop).
     crop = normierte {x,y,w,h} (0..1) der natürlichen Bildfläche. */
  function applyCropStyles(img, crop) {
    if (!crop) { img.removeAttribute('style'); return; }
    img.style.inset = 'auto';
    img.style.position = 'absolute';
    img.style.left = (-(crop.x / crop.w) * 100) + '%';
    img.style.top = (-(crop.y / crop.h) * 100) + '%';
    img.style.width = (100 / crop.w) + '%';
    img.style.height = (100 / crop.h) + '%';
    img.style.maxWidth = 'none';
    img.style.objectFit = 'cover';
  }

  /* ===================================================================
   * Stage-Rendering (Port aus collage-engine.html renderStage)
   * =================================================================== */
  function deepCloneLayout(l) {
    return {
      id: l.id, name: l.name, aspect: l.aspect, blanketPad: l.blanketPad,
      photoStyle: l.photoStyle, blanketColor: l.blanketColor,
      grid: Object.assign({}, l.grid),
      overlay: l.overlay ? Object.assign({}, l.overlay) : null,
      photos: l.photos.map(function (p) { return Object.assign({}, p); }),
      texts: l.texts.map(function (t) { return Object.assign({}, t); })
    };
  }

  function loadLayout(id) {
    activeLayout = deepCloneLayout(LAYOUTS[id] || LAYOUTS['photo-gallery']);
    state.texts = activeLayout.texts;
    state.bgColor = activeLayout.blanketColor || '#cccccc';
    state.design_color = state.bgColor;
    Object.keys(photoSrcs).forEach(function (k) { delete photoSrcs[k]; });
    Object.keys(slotData).forEach(function (k) { delete slotData[k]; });
    Object.keys(cropSource).forEach(function (k) { delete cropSource[k]; });
    // PROJ-4: KEINE Fleece-Textur mehr auf der Stage — sie ist jetzt die ehrliche
    // Druckfläche (der Print rendert ohne Textur; Stoff-Look kommt nur im Mockup).
    renderStage();
  }

  function renderStage() {
    const layout = activeLayout;
    stage.style.setProperty('--collage-aspect', layout.aspect);

    const grid = document.createElement('div');
    grid.className = 'collage-grid no-panel';
    grid.style.padding = layout.blanketPad + 'cqw';
    grid.style.setProperty('--blanket-color', state.bgColor);
    grid.style.gridTemplateColumns = layout.grid.cols;
    grid.style.gridTemplateRows = layout.grid.rows;
    grid.style.gap = layout.grid.gap + 'cqw';
    currentGrid = grid;

    layout.photos.forEach(function (ph, i) {
      const s = document.createElement('div');
      s.className = 'photo-slot' + (layout.photoStyle === 'mat' ? ' mat' : '');
      s.setAttribute('data-slot-index', i);
      if (photoSrcs[i]) {
        s.classList.add('has-photo');
        s.innerHTML = '<img class="photo" src="' + photoSrcs[i] + '" alt="">';
        const im = s.querySelector('img.photo');
        if (im && slotData[i] && slotData[i].crop) applyCropStyles(im, slotData[i].crop);
      } else {
        s.innerHTML = '<div class="cta">' + CAM + '<span>Foto</span></div>';
      }
      s.title = photoSrcs[i] ? 'Klicken: Foto zuschneiden' : 'Klicken: eigenes Foto laden';
      if (ph.x != null) {
        // Frei positionierte Slots: Position ist FIX aus dem Layout (kein Drag —
        // bewusst entfernt 2026-06-07, Kissen-Kompositionen sind designt; Tap = Crop/Upload)
        s.style.position = 'absolute';
        s.style.left = ph.x + '%'; s.style.top = ph.y + '%';
        s.style.width = ph.w + '%'; s.style.height = ph.h + '%';
        s.style.zIndex = 2 + i;
        if (ph.rot) s.style.transform = 'rotate(' + ph.rot + 'deg)';
      } else {
        s.style.gridColumn = ph.c; s.style.gridRow = ph.r;
      }
      s.style.cursor = 'pointer';
      // PROJ-5: gefüllter Slot → Crop-Modal; leerer Slot → Upload
      s.addEventListener('click', function () {
        if (photoSrcs[i]) openCropModal(i, s); else pickPhotoFor(i, s);
      });
      grid.appendChild(s);
    });

    if (layout.overlay && OVERLAY_BUILDERS[layout.overlay.type]) {
      const ov = document.createElement('div');
      ov.className = 'collage-overlay';
      ov.appendChild(OVERLAY_BUILDERS[layout.overlay.type](layout.overlay));
      grid.appendChild(ov);
    }

    state.texts.forEach(function (t, ti) {
      const el = document.createElement('div');
      el.className = 'text-slot';
      el.setAttribute('data-text-index', ti);
      el.style.fontFamily = "'" + (t.font || 'Playfair Display') + "', serif";
      el.style.fontWeight = t.weight || 700;
      el.style.color = t.color || '#28292d';
      el.style.fontSize = (t.size || 5) + 'cqw';
      if (t.upper) el.style.textTransform = 'uppercase';
      if (t.italic) el.style.fontStyle = 'italic';
      if (t.spacing) el.style.letterSpacing = t.spacing;
      el.textContent = t.content;
      el.style.position = 'absolute';
      el.style.left = (t.x != null ? t.x : 50) + '%';
      el.style.top = (t.y != null ? t.y : 50) + '%';
      el.style.transform = 'translate(-50%, -50%)';
      el.style.zIndex = 7; el.style.whiteSpace = 'nowrap'; el.style.justifyContent = 'center';
      grid.appendChild(el);
    });

    stage.innerHTML = '';
    stage.appendChild(grid);
    schedulePillow();
  }

  /* Drag-Verschieben der frei platzierten Fotos wurde bewusst ENTFERNT (2026-06-07):
     Kissen-Layouts (Herz-Collage, Vollbild, Love Paw) sind fixe Kompositionen —
     Verschieben zerstört das Design. Tap = Crop/Upload (Handler in renderStage).
     Falls später gewünscht: Decken-Editor makeDraggable als Vorlage. */

  /* ===================================================================
   * Foto-Upload pro Slot — objectURL-Sofortvorschau + S3 im Hintergrund
   * =================================================================== */
  let _uploadInput = null;
  function pickPhotoFor(i, slotEl) {
    if (!_uploadInput) {
      _uploadInput = document.createElement('input');
      _uploadInput.type = 'file'; _uploadInput.accept = 'image/jpeg,image/png,image/heic,image/heif';
      _uploadInput.style.display = 'none'; document.body.appendChild(_uploadInput);
    }
    const inp = _uploadInput; inp.value = ''; inp.multiple = false;
    inp.onchange = function () {
      const f = inp.files && inp.files[0];
      // PROJ-5: nach Einzel-Upload direkt das Crop-Modal öffnen (Decken-Pattern)
      if (f) setSlotImage(i, f, slotEl, function () { openCropModal(i, slotEl); });
    };
    inp.click();
  }

  /* Downscaled Kopie fürs Crop-Modal (2400px Long-Side) — verhindert Cropper-Lags
     bei 40-MP-Handyfotos. Print nutzt unverändert das S3-Original (Decken-Pattern). */
  function downscaleForCrop(file, maxSide) {
    return new Promise(function (resolve) {
      const url = URL.createObjectURL(file);
      const im = new Image();
      im.onload = function () {
        const w = im.naturalWidth, h = im.naturalHeight;
        if (!w || !h || (w <= maxSide && h <= maxSide)) { resolve(url); return; }
        const scale = maxSide / Math.max(w, h);
        const c = document.createElement('canvas');
        c.width = Math.round(w * scale); c.height = Math.round(h * scale);
        c.getContext('2d').drawImage(im, 0, 0, c.width, c.height);
        URL.revokeObjectURL(url);
        resolve(c.toDataURL('image/jpeg', 0.9));
      };
      im.onerror = function () { resolve(url); };
      im.src = url;
    });
  }

  function validateFile(f) {
    if (!ACCEPTED_TYPES.includes(f.type) && !/\.(jpg|jpeg|png|heic|heif)$/i.test(f.name)) {
      alert('Format nicht unterstützt — bitte JPG, PNG oder HEIC'); return false;
    }
    if (f.size > MAX_FILE_SIZE_MB * 1024 * 1024) {
      alert('Datei zu groß — max ' + MAX_FILE_SIZE_MB + ' MB'); return false;
    }
    return true;
  }

  function setSlotImage(i, file, slotEl, onReady) {
    if (!validateFile(file)) return;
    const url = URL.createObjectURL(file);
    photoSrcs[i] = url;
    cropSource[i] = url;
    slotData[i] = slotData[i] || {};
    slotData[i].crop = null;   // PROJ-5: neuer Upload → Crop zurücksetzen

    // DOM in-place aktualisieren (Drag-Positionen bleiben erhalten, kein Full-Render)
    if (!slotEl) slotEl = stage.querySelector('[data-slot-index="' + i + '"]');
    if (slotEl) {
      let img = slotEl.querySelector('img.photo');
      if (!img) {
        slotEl.classList.add('has-photo');
        const cta = slotEl.querySelector('.cta'); if (cta) cta.remove();
        img = document.createElement('img'); img.className = 'photo';
        slotEl.insertBefore(img, slotEl.firstChild);
      }
      img.removeAttribute('style');   // alte Crop-Styles entfernen
      img.src = url;
      slotEl.title = 'Klicken: Foto zuschneiden';
    }
    refreshSlotListItem(i);
    schedulePillow();

    // Original im Hintergrund nach S3
    uploadToS3(file).then(function (publicUrl) {
      slotData[i].user_image_url = publicUrl;
    }).catch(function (err) {
      console.error('[kissen] S3 upload failed for slot ' + i, err);
    });

    // Downscaled Version fürs Crop-Modal bereitstellen, DANN erst Crop öffnen.
    downscaleForCrop(file, 2400).then(function (durl) {
      cropSource[i] = durl;
      if (typeof onReady === 'function') onReady();
    });
  }

  async function uploadToS3(file) {
    const presignedResp = await fetch(BACKEND_API_URL + '/api/v1/upload/presigned-url/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ filename: file.name || 'kissen-photo.jpg', content_type: file.type || 'image/jpeg' }),
    });
    if (!presignedResp.ok) throw new Error('Presigned URL failed: HTTP ' + presignedResp.status);
    const presigned = await presignedResp.json();
    const uploadUrl = presigned.uploadUrl || presigned.upload_url;
    const publicUrl = presigned.publicUrl || presigned.public_url;
    const fields = presigned.fields || {};
    if (!uploadUrl || !publicUrl) throw new Error('Invalid presigned response');
    const formData = new FormData();
    Object.keys(fields).forEach(function (k) { formData.append(k, fields[k]); });
    formData.append('file', file);
    const uploadResp = await fetch(uploadUrl, { method: 'POST', body: formData });
    if (!uploadResp.ok && uploadResp.status !== 204) throw new Error('S3 upload failed: HTTP ' + uploadResp.status);
    return publicUrl;
  }

  /* ===================================================================
   * Crop-Modal (PROJ-5 — 1:1-Port vom Decken-Editor, Cropper.js on-demand)
   * =================================================================== */
  let _cropper = null, _cropBackdrop = null, _cropSlotIndex = null, _cropInitialRatio = null;
  function ensureCropper() {
    return new Promise(function (resolve, reject) {
      if (window.Cropper) { resolve(); return; }
      if (!document.querySelector('link[data-cropper]')) {
        const lk = document.createElement('link');
        lk.rel = 'stylesheet'; lk.href = CROPPER_CSS_URL; lk.setAttribute('data-cropper', '1');
        document.head.appendChild(lk);
      }
      const sc = document.createElement('script');
      sc.src = CROPPER_JS_URL;
      sc.onload = function () { resolve(); };
      sc.onerror = function () { reject(new Error('Cropper konnte nicht geladen werden')); };
      document.head.appendChild(sc);
    });
  }
  function buildCropBackdrop() {
    const bd = document.createElement('div');
    bd.className = 'collage-cropper-modal-backdrop';
    bd.innerHTML =
      '<div class="collage-cropper-modal">' +
        '<div class="collage-cropper-modal-header"><h3>Foto zuschneiden</h3></div>' +
        '<div class="collage-cropper-wrapper"><img alt=""></div>' +
        '<p class="collage-cropper-help">Verschiebe den Rahmen oder seine Ecken, um dein Bild zuzuschneiden. Mit Mausrad oder Slider kannst du zoomen.</p>' +
        '<div class="collage-cropper-zoom-bar">' +
          '<button type="button" class="collage-zoom-btn collage-zoom-out" aria-label="Verkleinern">−</button>' +
          '<input type="range" class="collage-zoom-slider" min="100" max="200" value="100" aria-label="Zoom">' +
          '<button type="button" class="collage-zoom-btn collage-zoom-in" aria-label="Vergrößern">+</button>' +
        '</div>' +
        '<div class="collage-cropper-modal-footer">' +
          '<button type="button" class="collage-crop-cancel">Abbrechen</button>' +
          '<button type="button" class="primary collage-crop-apply">Zuschneiden &amp; übernehmen</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(bd);
    bd.addEventListener('click', function (e) { if (e.target === bd) closeCropModal(); });
    bd.querySelector('.collage-crop-cancel').addEventListener('click', closeCropModal);
    bd.querySelector('.collage-crop-apply').addEventListener('click', applyCropFromModal);
    const zs = bd.querySelector('.collage-zoom-slider');
    if (zs) zs.addEventListener('input', function () {
      if (!_cropper || !_cropInitialRatio) return;
      _cropper.zoomTo(_cropInitialRatio * (parseInt(this.value, 10) / 100));
    });
    bd.querySelector('.collage-zoom-in').addEventListener('click', function () { if (_cropper) _cropper.zoom(0.1); });
    bd.querySelector('.collage-zoom-out').addEventListener('click', function () { if (_cropper) _cropper.zoom(-0.1); });
    return bd;
  }
  function openCropModal(i, slotEl) {
    _cropSlotIndex = i;
    if (!cropSource[i]) { pickPhotoFor(i, slotEl); return; }
    ensureCropper().then(function () {
      if (!_cropBackdrop) _cropBackdrop = buildCropBackdrop();
      _cropBackdrop.classList.add('visible');
      document.body.style.overflow = 'hidden';
      initCropperImage(i, slotEl);
    }).catch(function (e) { console.error(e); alert('Crop-Editor konnte nicht geladen werden.'); });
  }
  function initCropperImage(i, slotEl) {
    const img = _cropBackdrop.querySelector('.collage-cropper-wrapper img');
    if (_cropper) { _cropper.destroy(); _cropper = null; }
    let aspect = NaN;
    const el = slotEl || stage.querySelector('[data-slot-index="' + i + '"]');
    if (el) { const r = el.getBoundingClientRect(); if (r.width && r.height) aspect = r.width / r.height; }
    // img.onload kann doppelt feuern (synchron via if(img.complete) UND async via
    // Load-Event) -> zwei Cropper auf demselben Bild, der zweite kaputt. Single-Init-Sperre.
    let _built = false;
    img.onload = function () {
      if (_built) return; _built = true;
      // rAF wie Foto-Poster/Decke: ohne Frame-Aufschub misst Cropper.js den gerade
      // sichtbar gewordenen Container als 0x0 und positioniert die Crop-Box falsch.
      requestAnimationFrame(function () {
        _cropper = new Cropper(img, {
          aspectRatio: aspect || NaN,
          viewMode: 1, autoCropArea: 1,
          movable: true, zoomable: true, rotatable: false, scalable: false,
          cropBoxResizable: true, responsive: false, background: false, modal: true,
          dragMode: 'none', toggleDragModeOnDblclick: false, // kein Neu-Aufziehen ausserhalb der Box (Clarity 10.08.)
          minCropBoxWidth: 60, minCropBoxHeight: 60,
          wheelZoomRatio: 0.08,
          ready: function () {
            const cd = _cropper.getCanvasData();
            _cropInitialRatio = cd.naturalWidth ? (cd.width / cd.naturalWidth) : null;
            const zs = _cropBackdrop && _cropBackdrop.querySelector('.collage-zoom-slider');
            if (zs) zs.value = 100;
            const c = slotData[i] && slotData[i].crop;
            if (c) {
              const d = _cropper.getImageData();
              _cropper.setData({ x: c.x * d.naturalWidth, y: c.y * d.naturalHeight, width: c.w * d.naturalWidth, height: c.h * d.naturalHeight });
            }
          },
          zoom: function (ev) {
            if (!_cropInitialRatio) return;
            const zs = _cropBackdrop && _cropBackdrop.querySelector('.collage-zoom-slider');
            if (zs) { const pct = Math.round((ev.detail.ratio / _cropInitialRatio) * 100); zs.value = Math.max(100, Math.min(200, pct)); }
          }
        });
      });
    };
    img.src = cropSource[i];
    if (img.complete && img.naturalWidth) img.onload();
  }
  function applyCropFromModal() {
    if (!_cropper || _cropSlotIndex == null) { closeCropModal(); return; }
    const data = _cropper.getData();
    const id = _cropper.getImageData();
    const NW = id.naturalWidth || 1, NH = id.naturalHeight || 1;
    const crop = {
      x: Math.max(0, Math.min(1, data.x / NW)),
      y: Math.max(0, Math.min(1, data.y / NH)),
      w: Math.max(0.01, Math.min(1, data.width / NW)),
      h: Math.max(0.01, Math.min(1, data.height / NH))
    };
    slotData[_cropSlotIndex] = slotData[_cropSlotIndex] || {};
    slotData[_cropSlotIndex].crop = crop;
    const el = stage.querySelector('[data-slot-index="' + _cropSlotIndex + '"]');
    if (el) { const im = el.querySelector('img.photo'); if (im) applyCropStyles(im, crop); }
    schedulePillow();
    closeCropModal();
  }
  function closeCropModal() {
    if (_cropper) { _cropper.destroy(); _cropper = null; }
    if (_cropBackdrop) _cropBackdrop.classList.remove('visible');
    document.body.style.overflow = '';
    _cropSlotIndex = null;
  }

  /* ===================================================================
   * "Deine Fotos" — Pro-Slot-Liste im Layout-Tab (1:1 Decken-Pattern:
   * Thumb + "Foto N" + Upload/Ändern-Button; Thumb-Klick = Crop-Modal)
   * =================================================================== */
  function buildPhotoControls() {
    const host = document.getElementById('kissen-photo-controls-' + sectionId);
    if (!host) return;
    const n = activeLayout.photos.length;
    const ul = document.createElement('ul');
    ul.className = 'collage-photo-slot-list';
    for (let i = 0; i < n; i++) {
      const li = document.createElement('li');
      li.className = 'collage-photo-slot-item';
      li.setAttribute('data-slot-index', i);

      const thumb = document.createElement('span');
      thumb.className = 'collage-photo-slot-thumb';
      const timg = document.createElement('img'); timg.alt = '';
      timg.src = photoSrcs[i] || (assets && assets.placeholder) || '';
      thumb.appendChild(timg);

      const label = document.createElement('span');
      label.className = 'collage-photo-slot-label';
      label.textContent = 'Foto ' + (i + 1);

      const btn = document.createElement('label');
      btn.className = 'photo-upload-button collage-photo-slot-upload';
      const span = document.createElement('span');
      span.textContent = photoSrcs[i] ? 'Ändern' : 'Foto hochladen';
      const inp = document.createElement('input');
      inp.type = 'file'; inp.accept = 'image/jpeg,image/png,image/heic,image/heif';
      (function (idx) {
        inp.addEventListener('change', function (e) {
          const f = e.target.files && e.target.files[0];
          if (f) setSlotImage(idx, f, null, function () { openCropModal(idx, null); });
          e.target.value = '';
        });
        thumb.addEventListener('click', function () { if (photoSrcs[idx]) openCropModal(idx, null); });
      })(i);
      btn.appendChild(span); btn.appendChild(inp);

      li.appendChild(thumb); li.appendChild(label); li.appendChild(btn);
      ul.appendChild(li);
    }
    host.innerHTML = '';
    host.appendChild(ul);
  }

  function refreshSlotListItem(i) {
    const li = document.querySelector('.collage-photo-slot-item[data-slot-index="' + i + '"]');
    if (!li) return;
    const ti = li.querySelector('.collage-photo-slot-thumb img');
    if (ti && photoSrcs[i]) ti.src = photoSrcs[i];
    const sp = li.querySelector('.collage-photo-slot-upload span');
    if (sp && photoSrcs[i]) sp.textContent = 'Ändern';
  }

  function buildTextFields() {
    const host = document.getElementById('kissen-text-fields-' + sectionId);
    const textTab = root.querySelector('.kissen-tab-text');
    const editable = state.texts.map(function (t, i) { return { t: t, i: i }; }).filter(function (o) { return !o.t.fixed; });
    if (!host) return;
    if (editable.length === 0) {
      host.innerHTML = '';
      if (textTab) textTab.style.display = 'none';   // Layout ohne Text → Tab ausblenden
      return;
    }
    if (textTab) textTab.style.display = '';
    host.innerHTML = '';
    editable.forEach(function (o) {
      const wrap = document.createElement('div'); wrap.className = 'kissen-text-field';
      const lab = document.createElement('label');
      lab.setAttribute('for', 'kissen-text-' + o.i + '-' + sectionId);
      lab.textContent = o.t.label || 'Text';
      const inp = document.createElement('input');
      inp.type = 'text'; inp.id = 'kissen-text-' + o.i + '-' + sectionId;
      inp.value = o.t.content; inp.autocomplete = 'off'; inp.maxLength = 40;
      inp.addEventListener('input', function () {
        o.t.content = inp.value;
        const el = stage.querySelector('.text-slot[data-text-index="' + o.i + '"]');
        if (el) el.textContent = inp.value;
        schedulePillow();
      });
      wrap.appendChild(lab); wrap.appendChild(inp);
      host.appendChild(wrap);
    });
  }

  /* ===================================================================
   * Tabs / Größe / Farbe
   * =================================================================== */
  /* ===================================================================
   * Layout-Picker (PROJ-6 — Decken-Pattern): Thumbnails aller 5 Kissen-Designs.
   * Klick wechselt Layout UND Shopify-Produkt (Varianten-Mapping aus dem
   * Liquid-JSON #kissen-products-<sectionId>), inkl. URL via replaceState.
   * =================================================================== */
  let LAYOUT_PRODUCTS = {};
  function renderLayoutThumb(layout, host) {
    const thumbStage = document.createElement('div');
    thumbStage.className = 'collage-stage is-thumb';
    thumbStage.style.setProperty('--collage-aspect', layout.aspect);
    host.style.backgroundColor = layout.blanketColor || '#CBCBCB';
    thumbStage.style.height = '100%'; thumbStage.style.width = 'auto';

    const grid = document.createElement('div');
    grid.className = 'collage-grid no-panel';
    grid.style.padding = layout.blanketPad + 'cqw';
    grid.style.setProperty('--blanket-color', layout.blanketColor || '#CBCBCB');
    grid.style.gridTemplateColumns = layout.grid.cols;
    grid.style.gridTemplateRows = layout.grid.rows;
    grid.style.gap = layout.grid.gap + 'cqw';
    layout.photos.forEach(function (ph, i) {
      const s = document.createElement('div');
      s.className = 'photo-slot' + (layout.photoStyle === 'mat' ? ' mat' : '');
      if (ph.x != null) {
        s.style.position = 'absolute';
        s.style.left = ph.x + '%'; s.style.top = ph.y + '%';
        s.style.width = ph.w + '%'; s.style.height = ph.h + '%';
        s.style.zIndex = 2 + i;
        if (ph.rot) s.style.transform = 'rotate(' + ph.rot + 'deg)';
      } else {
        s.style.gridColumn = ph.c; s.style.gridRow = ph.r;
      }
      grid.appendChild(s);
    });
    if (layout.overlay && OVERLAY_BUILDERS[layout.overlay.type]) {
      const ov = document.createElement('div'); ov.className = 'collage-overlay';
      ov.appendChild(OVERLAY_BUILDERS[layout.overlay.type](layout.overlay));
      grid.appendChild(ov);
    }
    layout.texts.forEach(function (t) {
      const el = document.createElement('div'); el.className = 'text-slot';
      el.style.fontFamily = "'" + (t.font || 'Playfair Display') + "', serif";
      el.style.fontWeight = t.weight || 700;
      el.style.color = t.color || '#28292d';
      el.style.fontSize = (t.size || 5) + 'cqw';
      if (t.upper) el.style.textTransform = 'uppercase';
      if (t.spacing) el.style.letterSpacing = t.spacing;
      el.textContent = t.content;
      el.style.position = 'absolute';
      el.style.left = (t.x != null ? t.x : 50) + '%';
      el.style.top = (t.y != null ? t.y : 50) + '%';
      el.style.transform = 'translate(-50%, -50%)';
      el.style.zIndex = 7; el.style.whiteSpace = 'nowrap';
      grid.appendChild(el);
    });
    thumbStage.appendChild(grid);
    host.appendChild(thumbStage);
  }

  function switchProduct(id) {
    const prod = LAYOUT_PRODUCTS[id];
    if (!prod || !prod.variants) return;
    // Größen-Picker auf die Varianten des neuen Produkts umschreiben (Größen/Preise
    // sind über alle Kissen identisch — nur die variant_ids unterscheiden sich).
    root.querySelectorAll('.kissen-size-option').forEach(function (opt) {
      const v = prod.variants[opt.dataset.size];
      if (v) { opt.dataset.variantId = String(v.id); if (v.price) opt.dataset.price = v.price; }
    });
    const current = root.querySelector('.kissen-size-option.current');
    if (current) state.variant_id = current.dataset.variantId;
    const variantInput = document.getElementById('kissen-variant-id-' + sectionId);
    if (variantInput && state.variant_id) variantInput.value = state.variant_id;
    // URL still auf die zugehörige Gestalten-Page (Sharing/Reload landet richtig)
    if (prod.handle && window.history && history.replaceState) {
      try { history.replaceState(null, '', '/pages/' + prod.handle + '-gestalten'); } catch (e) { /* still */ }
    }
  }

  function buildLayoutPicker() {
    const host = document.getElementById('kissen-layout-picker-' + sectionId);
    if (!host) return;
    host.innerHTML = '';
    const ul = document.createElement('ul');
    ul.className = 'collage-template-picker';
    Object.keys(LAYOUTS).forEach(function (id) {
      const l = LAYOUTS[id];
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.href = '#';
      a.className = 'collage-template' + (id === layoutId ? ' current' : '');
      a.setAttribute('aria-label', l.name);
      const thumb = document.createElement('span');
      thumb.className = 'collage-template-thumb';
      renderLayoutThumb(l, thumb);
      const name = document.createElement('span');
      name.className = 'collage-template-name';
      name.textContent = l.name;
      a.appendChild(thumb); a.appendChild(name);
      a.addEventListener('click', function (e) {
        e.preventDefault();
        if (id === layoutId) return;
        ul.querySelectorAll('.collage-template').forEach(function (x) { x.classList.remove('current'); });
        a.classList.add('current');
        layoutId = id;
        loadLayout(id);          // resettet Fotos/Texte/Crops (wie Decke)
        buildPhotoControls();
        buildTextFields();
        switchProduct(id);
      });
      li.appendChild(a); ul.appendChild(li);
    });
    host.appendChild(ul);
  }

  function initTabSwitching() {
    const tabs = root.querySelectorAll('.main__switcher > ul > li > a[data-tab]');
    const panels = ['layout__wrapper', 'foto__wrapper', 'text__wrapper', 'produkt__wrapper'];
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function (e) {
        e.preventDefault();
        const target = tab.dataset.tab;
        tabs.forEach(function (t) { t.classList.remove('current'); });
        tab.classList.add('current');
        panels.forEach(function (cls) {
          const el = root.querySelector('.' + cls);
          if (el) el.style.display = (cls === target) ? '' : 'none';
        });
        // PROJ-4: Produkt-Tab geöffnet → Mockup on-demand aktualisieren
        if (target === 'produkt__wrapper') renderMockupIfDirty();
      });
    });
  }

  function initSizePicker() {
    const opts = root.querySelectorAll('.kissen-size-option');
    const variantInput = document.getElementById('kissen-variant-id-' + sectionId);
    const first = opts[0];
    if (first) {
      state.paper_size = first.dataset.size;
      state.variant_id = first.dataset.variantId;
    }
    opts.forEach(function (opt) {
      opt.addEventListener('click', function (e) {
        e.preventDefault();
        opts.forEach(function (o) { o.classList.remove('current'); });
        opt.classList.add('current');
        state.paper_size = opt.dataset.size;
        state.variant_id = opt.dataset.variantId;
        if (variantInput) variantInput.value = state.variant_id;
        const priceStr = opt.dataset.price || '';
        const priceEl = root.querySelector('.bottom__controls .variant-price');
        if (priceEl && priceStr) { priceEl.textContent = priceStr + ' €'; priceEl.dataset.price = priceStr; }
      });
    });
  }

  function initColorPicker() {
    const links = root.querySelectorAll('.blanket-color-picker .wrap a');
    const customInput = document.getElementById('kissen-custom-color-' + sectionId);
    function apply(hex) {
      state.bgColor = hex; state.design_color = hex;
      if (currentGrid) currentGrid.style.setProperty('--blanket-color', hex);
      schedulePillow();
    }
    links.forEach(function (link) {
      link.addEventListener('click', function (e) {
        if (link.classList.contains('custom')) return;
        e.preventDefault();
        links.forEach(function (l) { l.classList.remove('current'); });
        link.classList.add('current');
        const c = link.getAttribute('data-color');
        if (c) apply(c);
      });
    });
    if (customInput) {
      let deb;
      customInput.addEventListener('input', function () {
        const self = this; const customLink = self.closest('a');
        if (customLink) { links.forEach(function (l) { l.classList.remove('current'); }); customLink.classList.add('current'); }
        clearTimeout(deb); deb = setTimeout(function () { apply(self.value); }, 120);
      });
    }
  }

  /* ===================================================================
   * Kissen-Mockup im Produkt-Tab (PROJ-4 — BUILD-16-Port aus collage-engine.html)
   * ===================================================================
   * Gestalten = flache Stage (Druckfläche). Beim Öffnen des Produkt-Tabs wird das
   * Design einmalig per html2canvas gerendert und ZEILENWEISE auf die Stoffbreite
   * der Kissen-Silhouette gemappt (edge-to-edge bis in Nähte/Zipfel — wie die
   * echten Merchone-Produktfotos). Mitte ≈ 1:1 unverzerrt, Ränder laufen in die
   * Wölbung. schedulePillow() markiert nur dirty — gerendert wird on-demand.
   * =================================================================== */
  let _mockupDirty = true, _mockupBusy = false;
  let _profL = null, _profR = null, _profW = 0, _profH = 0;
  let _designCanvas = null, _lastDesignSrc = null;

  function schedulePillow() { _mockupDirty = true; }

  /* Zeilen-Profile L(y)/R(y) aus der Silhouetten-Maske (einmalig, lazy) */
  let _profilePromise = null;
  function ensureProfiles() {
    if (_profilePromise) return _profilePromise;
    _profilePromise = new Promise(function (resolve, reject) {
      const im = new Image();
      im.crossOrigin = 'anonymous';   // Shopify-CDN liefert CORS-Header
      im.onload = function () {
        _profW = im.naturalWidth; _profH = im.naturalHeight;
        const c = document.createElement('canvas'); c.width = _profW; c.height = _profH;
        const ctx = c.getContext('2d', { willReadFrequently: true });
        ctx.drawImage(im, 0, 0);
        const d = ctx.getImageData(0, 0, _profW, _profH).data;
        _profL = new Int16Array(_profH); _profR = new Int16Array(_profH);
        for (let y = 0; y < _profH; y++) {
          let Lx = -1, Rx = -1;
          for (let x = 0; x < _profW; x++) { if (d[(y * _profW + x) * 4 + 3] > 128) { Lx = x; break; } }
          for (let x = _profW - 1; x >= 0; x--) { if (d[(y * _profW + x) * 4 + 3] > 128) { Rx = x; break; } }
          _profL[y] = Lx; _profR[y] = Rx;
        }
        resolve();
      };
      im.onerror = function () { reject(new Error('Silhouetten-Maske konnte nicht geladen werden')); };
      im.src = assets.flatlayShape;
    });
    return _profilePromise;
  }

  function warpInto(srcCanvas) {
    if (!_profL || !_designCanvas) return;
    if (_designCanvas.width !== _profW) { _designCanvas.width = _profW; _designCanvas.height = _profH; }
    const g = _designCanvas.getContext('2d');
    g.clearRect(0, 0, _profW, _profH);
    const sw = srcCanvas.width, shh = srcCanvas.height, rowH = shh / _profH;
    for (let y = 0; y < _profH; y++) {
      const Lx = _profL[y], Rx = _profR[y];
      if (Lx < 0 || Rx <= Lx) continue;
      g.drawImage(srcCanvas, 0, y * rowH, sw, Math.max(rowH, 1), Lx, y, Rx - Lx + 1, 1);
    }
  }

  /* html2canvas 1.4.1 rendert object-fit:cover in den Slots NICHT (Fotos würden
     gestreckt). Fix: Fotos vor dem Capture selbst auf das Slot-Verhältnis croppen
     und im onclone-Klon einsetzen. Slots MIT Kunden-Crop nutzen applyCropStyles
     (absolute Positionierung) — die rendert html2canvas korrekt, kein Eingriff. */
  const _coverCropCache = new Map();
  function coverCropFor(img) {
    if (img.style.position === 'absolute') return null;   // Kunden-Crop aktiv → ok
    const bw = img.clientWidth, bh = img.clientHeight;
    const nw = img.naturalWidth, nh = img.naturalHeight;
    if (!bw || !bh || !nw || !nh) return null;
    const key = img.src + '|' + (bw / bh).toFixed(3);
    if (_coverCropCache.has(key)) return _coverCropCache.get(key);
    const boxR = bw / bh, natR = nw / nh;
    let sx, sy, sw2, sh2;
    if (natR > boxR) { sh2 = nh; sw2 = nh * boxR; sx = (nw - sw2) / 2; sy = 0; }
    else { sw2 = nw; sh2 = nw / boxR; sx = 0; sy = (nh - sh2) / 2; }
    const cv = document.createElement('canvas');
    cv.width = Math.min(1400, Math.round(bw * 2)); cv.height = Math.round(cv.width / boxR);
    cv.getContext('2d').drawImage(img, sx, sy, sw2, sh2, 0, 0, cv.width, cv.height);
    const url = cv.toDataURL('image/jpeg', 0.92);
    _coverCropCache.set(key, url);
    return url;
  }

  async function renderMockup() {
    if (_mockupBusy || !window.html2canvas || !_designCanvas) return;
    _mockupBusy = true;
    try {
      await ensureProfiles();
      const photos = stage.querySelectorAll('img.photo');
      const crops = Array.prototype.map.call(photos, function (p) { return coverCropFor(p); });
      const cv = await html2canvas(stage, { backgroundColor: null, scale: 1.6, useCORS: true, logging: false,
        onclone: function (doc) {
          const stageClone = doc.getElementById(stage.id);
          if (!stageClone) return;
          stageClone.querySelectorAll('img.photo').forEach(function (c, i) {
            if (crops[i]) { c.src = crops[i]; c.style.objectFit = 'fill'; }
          });
        } });
      warpInto(cv);
      _mockupDirty = false;
    } catch (e) {
      console.error('[kissen] Mockup-Render fehlgeschlagen', e);
    }
    _mockupBusy = false;
  }

  function renderMockupIfDirty() {
    if (_mockupDirty) renderMockup();
  }

  /* ===================================================================
   * Cart-Add
   * =================================================================== */
  async function handleCartAdd() {
    const cartBtn = document.getElementById('kissen-cart-btn-' + sectionId);
    if (!state.variant_id) { alert('Bitte Größe wählen'); return; }
    const filled = activeLayout.photos.map(function (_, i) { return i; }).filter(function (i) { return slotData[i] && slotData[i].user_image_url; });
    if (filled.length === 0) {
      alert('Bitte lade mindestens 1 eigenes Foto hoch.');
      return;
    }
    cartBtn.disabled = true; cartBtn.textContent = 'Wird vorbereitet…';
    try {
      const jobId = (crypto && crypto.randomUUID) ? crypto.randomUUID() : (Date.now() + '-' + Math.random().toString(36).slice(2));
      const photoSlotsOut = {};
      activeLayout.photos.forEach(function (ph, i) {
        photoSlotsOut['p' + (i + 1)] = {
          user_image_url: (slotData[i] && slotData[i].user_image_url) || '',
          crop: (slotData[i] && slotData[i].crop) || null,   // PROJ-5: Zoom-Ausschnitt → Druck (Server liest crop bereits)
          pos: (ph.x != null) ? { x: ph.x, y: ph.y, w: ph.w, h: ph.h, rot: ph.rot || 0 } : null
        };
      });
      const textSlotsOut = state.texts.map(function (t) { return { content: t.content, x: t.x, y: t.y }; });
      const payload = {
        job_id: jobId,
        product: 'kissen',
        layout_id: layoutId,
        paper_size: state.paper_size,
        variant_id: state.variant_id,
        photo_slots: photoSlotsOut,
        text_slots: textSlotsOut,
        design_color: state.design_color,
      };

      // Render-Trigger (Phase 3): existiert noch nicht → 404 ist OK, Fallback-URL nutzen.
      let printImageUrl = BACKEND_API_URL + '/api/v1/kissen/data/' + jobId + '/';
      try {
        const renderResp = await fetch(BACKEND_API_URL + '/api/v1/kissen/render/', {
          method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
        });
        if (renderResp.ok || renderResp.status === 202) {
          const rd = await renderResp.json().catch(function () { return {}; });
          printImageUrl = rd.print_image_url || printImageUrl;
        }
      } catch (e) { /* Backend Phase 3 noch nicht live — Fallback bleibt */ }

      const cartProperties = {
        '_Kissen Config JSON': JSON.stringify(payload),
        '_Layout': layoutId,
        '_print_image_url': printImageUrl,
        '_job_id': jobId,
        '_Provider': 'merchone',
        '_Größe': state.paper_size,
        '_Hintergrundfarbe': state.design_color,
      };
      // Cart-Properties IMMER _-geprefixt -> im Warenkorb versteckt (nur Name/Preis/Variante sichtbar)
      state.texts.forEach(function (t) {
        if (!t.fixed && t.content) cartProperties['_' + (t.label || 'Text')] = t.content;
      });
      activeLayout.photos.forEach(function (_, i) {
        if (slotData[i] && slotData[i].user_image_url) cartProperties['_Foto ' + (i + 1)] = slotData[i].user_image_url;
      });

      const cartResp = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(state.variant_id, 10), quantity: 1, properties: cartProperties }] }),
      });
      if (!cartResp.ok) throw new Error('Cart-Add HTTP ' + cartResp.status);

      let cartData = null;
      try {
        cartData = await cartResp.json();
        if (window.DLTrack && window.DLTrack.addToCart) window.DLTrack.addToCart(cartData);
      } catch (e) { /* skip tracking */ }

      // Pattern wie photo.js:1782 — theme.js-Listener erwarten detail.cart,
      // ohne detail werfen sie TypeErrors (QA-Befund PROJ-9, 2026-06-07)
      document.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { cart: cartData } }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.show === 'function') cartDrawer.show();
      else window.location.href = '/cart';
    } catch (err) {
      console.error('[kissen] Cart-add failed', err);
      alert('Konnte nicht in den Warenkorb legen — ' + (err.message || 'Unbekannter Fehler'));
    } finally {
      cartBtn.disabled = false; cartBtn.textContent = 'In den Warenkorb';
    }
  }

  /* ===================================================================
   * Init
   * =================================================================== */
  function init() {
    root = document.querySelector('.kissen-customizer');
    if (!root) return;
    sectionId = root.dataset.sectionId;
    layoutId = root.dataset.layoutId || 'photo-gallery';
    stage = document.getElementById('kissen-stage-' + sectionId);
    assets = {
      flatlayShape: root.dataset.assetFlatlayShape,
      placeholder: root.dataset.assetPlaceholder,
    };
    const mockupHost = document.getElementById('kissen-mockup-' + sectionId);
    if (mockupHost) _designCanvas = mockupHost.querySelector('.kissen-mockup-design');

    // PROJ-6: Produkt-Mapping für den Layout-Picker (Liquid-JSON)
    try {
      const pj = document.getElementById('kissen-products-' + sectionId);
      if (pj) LAYOUT_PRODUCTS = JSON.parse(pj.textContent);
    } catch (e) { console.error('[kissen] Produkt-Mapping unlesbar', e); }

    loadLayout(layoutId);
    buildLayoutPicker();
    buildPhotoControls();
    buildTextFields();
    initTabSwitching();
    initSizePicker();
    initColorPicker();

    const cartBtn = document.getElementById('kissen-cart-btn-' + sectionId);
    if (cartBtn) cartBtn.addEventListener('click', handleCartAdd);

    // aktive Farb-Kachel anwenden
    const currentSwatch = root.querySelector('.blanket-color-picker .wrap a.current[data-color]');
    if (currentSwatch) {
      const c = currentSwatch.getAttribute('data-color');
      if (c) { state.bgColor = c; state.design_color = c; if (currentGrid) currentGrid.style.setProperty('--blanket-color', c); }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
